import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Disclaimer = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Disclaimer", "terms/disclaimer_body_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Disclaimer || { Main: {} };

  return (
    <div className="container py-5 text-start" style={{ lineHeight: "1.8em" }}>
      <h2 className="mb-4">{LANGUAGE.Main.Content1}</h2>

      <h4>{LANGUAGE.Main.Content2}</h4>
      <p>
        {LANGUAGE.Main.Content3} <strong>{LANGUAGE.Main.Content4}</strong> {LANGUAGE.Main.Content5}
      </p>
      <p>{LANGUAGE.Main.Content6}</p>

      <h4>{LANGUAGE.Main.Content7}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content8}</strong>
          <p>{LANGUAGE.Main.Content9}</p>
          <p>{LANGUAGE.Main.Content10}</p>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content11}</strong>
          <p>{LANGUAGE.Main.Content12}</p>
          <p>{LANGUAGE.Main.Content13}</p>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content14}</strong>
          <p>{LANGUAGE.Main.Content15}</p>
          <p>{LANGUAGE.Main.Content16}</p>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content16_1}</h4>
      <ul>
        <li>
          <p>{LANGUAGE.Main.Content16_2}</p>
          <p>{LANGUAGE.Main.Content16_3}</p>
          <p>{LANGUAGE.Main.Content16_4}</p>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content17}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content18}</strong>
          <p>{LANGUAGE.Main.Content19}</p>
          <pre>{LANGUAGE.Main.Content20}</pre>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content21}</strong>
          <p>{LANGUAGE.Main.Content22}</p>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content23}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content24}</strong>
          <p>{LANGUAGE.Main.Content25}</p>
          <p>{LANGUAGE.Main.Content26}</p>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content27}</strong>
          <p>{LANGUAGE.Main.Content28}</p>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content29}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content30}</strong>
          <p>{LANGUAGE.Main.Content31}</p>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content32}</strong>
          <p>{LANGUAGE.Main.Content33}</p>
          <p>{LANGUAGE.Main.Content34}</p>
        </li>
      </ul>

      <hr className="my-4" />

      <h5>{LANGUAGE.Main.Content35}</h5>
      <p>
        {LANGUAGE.Main.Content36}<br />
        <strong>{LANGUAGE.Main.Content37}</strong> {LANGUAGE.Main.Content38}<br />
        <strong>{LANGUAGE.Main.Content39}</strong> <a href={`mailto:${LANGUAGE.Main.Content40}`}>{LANGUAGE.Main.Content40}</a><br />
        <strong>{LANGUAGE.Main.Content41}</strong> <a href={LANGUAGE.Main.Content42} target="_blank" rel="noopener noreferrer">{LANGUAGE.Main.Content42}</a>
      </p>
    </div>
  );
};

export default Disclaimer;
